module.exports = __webpack_public_path__ + "img/icon-filter.c1c65310.svg";